import BaseApi from './BaseApi';

export type MessageDetails = {
  channelId: string;
  messageId: string;
};

/**
 * メッセージ編集・削除API。
 */
class MessageApi extends BaseApi {
  private getUrl(data: MessageDetails) {
    return `messageApi?${Object.entries({
      ...(data.channelId.includes('/')
        ? {
            ...data,
            channelId: data.channelId.substring(
              data.channelId.lastIndexOf('/') + 1
            )
          }
        : data)
    })
      .filter(([key]) => key !== 'content')
      .map((entry) => entry.join('='))
      .join('&')}`;
  }
  async put(data: MessageDetails & { content: string }) {
    return await this.execute(this.getUrl(data), {
      method: 'PUT',
      body: { content: data.content }
    }).then(({ status }) => status === 1);
  }
  async delete(data: MessageDetails) {
    return await this.execute(this.getUrl(data), {
      method: 'DELETE'
    }).then(({ status }) => status === 1);
  }
}

export default MessageApi;
